// Styles
import styles from './TablePagination.module.css';

/**
 * TablePagination component - Fixed container at the bottom of the page
 * @param {object} props - Component props
 * @param {boolean} [props.navIsOpen] - Whether the navigation is open
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} The TablePagination component
 */
function TablePagination({
  navIsOpen = false,
  children,
}) {
  return (
    <div className={`${styles['table-pagination']} ${navIsOpen ? styles['table-pagination-open'] : ''}`}>
      <div className={styles['table-pagination-container']}>
        {children}
      </div>
    </div>
  );
}

export default TablePagination;
